import { ApiInfo } from '@/types/api.types';
import apiService from '@/services/api.service';
import { mapObjectKeys } from '@/helpers/object.helper';

let info: ApiInfo | undefined;

export default {
    async getInfo(refresh = false): Promise<ApiInfo | undefined> {
        if (!info || refresh) {
            const result = await apiService.get('info');

            info = result?.status === 200 ? result.data : undefined;
        }

        return info;
    },

    async getFeatures(): Promise<Record<string, boolean>> {
        const data = await this.getInfo();

        return data ? mapObjectKeys(data.features, (key) => key.toUpperCase()) : {};
    },
};
